import { PaginatedAgentsPayload } from 'app/modules/agents/requests';
import { selectSearchV2Enabled } from 'app/shared/featureFlags/selectors';
import { U21SelectOptionProps } from 'app/shared/u21-ui/components';
import { U21AgentSelect } from 'app/shared/u21-ui/components/dashboard';
import {
  U21AgentSearch,
  U21AgentSearchProps,
} from 'app/shared/u21-ui/components/dashboard/U21AgentSearch';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const AgentSearch = <TClearable extends boolean>(
  props: U21AgentSearchProps<TClearable> & {
    selector?: (state: RootState) => U21SelectOptionProps<number>[];
  },
) => {
  const { allowedStatuses, allowedQueueIds, selector, ...rest } = props;
  const isSearchV2Enabled = useSelector(selectSearchV2Enabled);

  const updatedPayload = useMemo(() => {
    const initialPayload: Partial<PaginatedAgentsPayload> = {};

    if (allowedStatuses) {
      initialPayload.statuses = allowedStatuses;
    }

    if (allowedQueueIds) {
      initialPayload.queue_ids = allowedQueueIds;
    }

    return initialPayload;
  }, [allowedQueueIds, allowedStatuses]);

  return isSearchV2Enabled ? (
    <U21AgentSearch {...props} />
  ) : (
    <U21AgentSelect
      getPayload={(payload) => ({
        ...payload,
        ...updatedPayload,
      })}
      selector={selector}
      {...rest}
    />
  );
};
